import axios from "axios";

const GetCustomizerDesign = async (customer, design) => {
  try {
    const response = await axios({
      url: `${process.env.REACT_APP_SHOPIFY_PROXY_URL}/api/graphql`,
      method: "POST",
      data: {
        query: `{
          customer(id: "gid://shopify/Customer/${customer}") {
            designs: metafield(key:"customizer_designs", namespace:"integration") {
              value
            }
          }
        }`,
      },
    });
    if (response.data.body.data.customer) {
      const { designs } = response.data.body.data.customer;
      const parsed = JSON.parse(decodeURIComponent(designs.value));
      return parsed[design];
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default GetCustomizerDesign;
